// extracted by mini-css-extract-plugin
module.exports = {"hero":"styles_hero__MLEzf","hero-image":"styles_hero-image__BfTly"};